var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InputFeedback from "../Feedback/InputFeedback";
import Checkbox from "./Checkbox";
import { classNames } from "../../Util";
var InputCheckbox = function (_a) {
    var id = _a.id, displayName = _a.displayName, defaultChecked = _a.defaultChecked, _b = _a.disabled, disabled = _b === void 0 ? false : _b, error = _a.error, reactHookForm = _a.reactHookForm;
    return (_jsxs("div", { children: [_jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx(Checkbox, { id: id, displayName: displayName, reactHookForm: reactHookForm, defaultChecked: defaultChecked, disabled: disabled }), _jsx("label", __assign({ htmlFor: id, className: classNames("ml-2 block text-sm", disabled ? "text-gray-500" : "text-gray-700") }, { children: displayName }))] })), _jsx(InputFeedback, { type: "error", message: error })] }));
};
export default InputCheckbox;
